import React from "react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";

const PlatformCard = ({
  platform,
  isConnected,
  followers,
  growth,
  onClick,
  onDisconnect,
  className = "",
}) => {
  const platformColors = {
    facebook: "bg-facebook",
    instagram: "bg-gradient-to-r from-purple-500 to-pink-500",
    twitter: "bg-twitter",
    linkedin: "bg-linkedin",
    youtube: "bg-youtube",
    tiktok: "bg-tiktok",
  };

  const platformIcons = {
    facebook: "📘",
    instagram: "📷",
    twitter: "🐦",
    linkedin: "💼",
    youtube: "📺",
    tiktok: "🎵",
  };

  return (
    <div
      className={`
        relative p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md
        ${
          isConnected
            ? "border-green-500 bg-green-50 hover:bg-green-100"
            : "border-gray-200 bg-gray-50 hover:bg-gray-100 hover:border-primary-500"
        }
        ${className}
      `}
      onClick={onClick}
    >
      <div className="flex flex-col items-center text-center">
        {/* Platform Icon */}
        <div
          className={`w-12 h-12 rounded-lg ${platformColors[platform] || "bg-gray-400"} flex items-center justify-center mb-3`}
        >
          <span className="text-2xl">{platformIcons[platform] || "🔗"}</span>
        </div>

        {/* Platform Name */}
        <h3 className="text-sm font-medium text-gray-900 mb-2 capitalize">
          {platform}
        </h3>

        {/* Connection Status */}
        <div className="flex items-center mb-2">
          {isConnected ? (
            <CheckCircleIcon className="w-4 h-4 text-green-500 mr-1" />
          ) : (
            <XCircleIcon className="w-4 h-4 text-gray-400 mr-1" />
          )}
          <span
            className={`text-xs font-medium ${
              isConnected ? "text-green-600" : "text-gray-400"
            }`}
          >
            {isConnected ? "Connected" : "Not Connected"}
          </span>
        </div>

        {/* Metrics (if connected) */}
        {isConnected && followers && (
          <div className="text-center">
            <div className="text-xs text-gray-600 mb-1">
              {followers} followers
            </div>
            {growth && (
              <div
                className={`text-xs font-medium ${
                  growth.startsWith("+") ? "text-green-600" : "text-red-600"
                }`}
              >
                {growth}
              </div>
            )}
          </div>
        )}

        {/* Action hint */}
        {!isConnected && (
          <div className="text-xs text-gray-400 mt-1">Click to connect</div>
        )}

        {/* Disconnect button (if connected) */}
        {isConnected && onDisconnect && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDisconnect(platform);
            }}
            className="absolute top-2 right-2 text-gray-400 hover:text-red-500 transition-colors"
            title="Disconnect"
          >
            <XCircleIcon className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default PlatformCard;
